import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
export const TableThemeNewsDisplay = ({ backgroundImagePath, themeTableProperties }) => {
    return (_jsx("div", { css: css `
        background: url(${backgroundImagePath});
        width: 100px;
        height: 100px;
        margin: 3px;
        border: 2px solid black;
      `, children: _jsx("div", { css: css `
          background-color: ${color(themeTableProperties.tableFeltColorNum).string()};
          border: 4px solid ${color(themeTableProperties.tableRailSolidColorNum).string()};
          border-radius: 30px;
          width: 80px;
          height: 60px;
          left: 10px;
          top: 20px;
          position: relative;
        ` }) }));
};
